<template>
  <v-container class="home">
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined style="text-align: center" class="crane-border-pink">
          <v-row>
            <v-col><h2 class="mt-5">Staff</h2></v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col><h2 class="subtitle-2">Professor</h2></v-col>
          </v-row>
          <v-row class="pa-3">
            <v-col>
              <v-card class="profile">
                <v-card-text>
                  <img
                    :src="`images/${professor.img}`"
                    :id="professor.login"
                    @mouseover="professor.img = professor.craneImage"
                    @mouseout="professor.img = professor.face"
                  />
                  <p><strong>Tom Doeppner</strong></p>
                  <p>
                    <i>{{ professor.pronouns }}</i>
                  </p>
                  <p>{{ professor.text }} ({{ professor.office }})</p>
                  <a href="mailto:twd@cs.brown.edu">twd@cs.brown.edu</a>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col><h2 class="subtitle-2">HTA</h2></v-col>
          </v-row>
          <v-row class="pa-3">
            <v-card class="profile">
              <v-card-text>
                <img
                  :src="`images/${hta.img}`"
                  :id="hta.login"
                  @mouseover="hta.img = hta.craneImage"
                  @mouseout="hta.img = hta.face"
                />
                <p>
                  <strong>{{ hta.name }}</strong>
                </p>
                <p>
                  <i>{{ hta.pronouns }}</i>
                </p>
                <p>{{ hta.text || "" }}</p>
                <a :href="`mailto:${hta.login}@cs.brown.edu`"
                  >{{ hta.login }}@cs.brown.edu</a
                >
              </v-card-text>
            </v-card>
          </v-row>
          <v-row>
            <v-col><h2 class="subtitle-2">UTA</h2></v-col>
          </v-row>
          <v-row class="pa-3" justify="center">
            <v-col
              v-for="uta in utas"
              :key="uta.login"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card class="profile">
                <v-card-text>
                  <img
                    :src="`images/${uta.img}`"
                    :id="uta.login"
                    @mouseover="uta.img = uta.craneImage"
                    @mouseout="uta.img = uta.face"
                  />
                  <p>
                    <strong>{{ uta.name }}</strong>
                  </p>
                  <p>
                    <i>{{ uta.pronouns }}</i>
                  </p>
                  <p>{{ uta.text || "" }}</p>
                  <a :href="`mailto:${uta.login}@cs.brown.edu`"
                    >{{ uta.login }}@cs.brown.edu</a
                  >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    professor: {
      name: "Tom Doeppner",
      login: "twd",
      pronouns: "he/him",
      img: "tom.jpg",
      face: "tom.jpg",
      text: "Hours: MWF 3-4pm",
      office: "CIT 405",
      craneImage: "crane/20200920_095455.jpg",
    },
    hta: {
      name: "Floria Tsui",
      login: "ftsui",
      pronouns: "she/her",
      img: "floria.jpg",
      face: "floria.jpg",
      craneImage: "crane/20200114_200648.jpg",
    },
    utas: [
      {
        name: "Divyam Dang",
        login: "ddang4",
				pronouns: "he/him",
        img: "divyam.jpg",
        face: "divyam.jpg",
        craneImage: "crane/20200122_202307.jpg",
      },
      {
        name: "James Yang",
        login: "jyang203",
        img: "james.jpg",
        face: "james.jpg",
        craneImage: "crane/default.jpg",
      },
      {
        name: "Nick Cancellaro",
        login: "ncancell",
        pronouns: "he/him",
        img: "nick.jpg",
        face: "nick.jpg",
        craneImage: "crane/20191206_163628.jpg",
      },
      {
        name: "Peter Theodores",
        login: "ptheodor",
        pronouns: "he/him",
        img: "peter.jpg",
        face: "peter.jpg",
        craneImage: "crane/20200212_232414.jpg",
      },
      {
        name: "Richard Abou Chaaya",
        login: "raboucha",
        img: "richard.jpg",
        face: "richard.jpg",
        craneImage: "crane/FB_IMG_1580794874838.jpg",
      },
      {
        name: "Thomas Castleman",
        login: "tcastlem",
        pronouns: "he/him",
        img: "thomas.jpg",
        face: "thomas.jpg",
        craneImage: "crane/20200118_211800.jpg",
      },
      {
        name: "Charlie Gagnon",
        login: "cgagnon1",
        pronouns: "he/him",
				img: "charlie.jpg",
        face: "charlie.jpg",
        craneImage: "crane/20200117_183519.jpg",
      },
    ],
  }),
};
</script>
<style scoped>
@import "../styles/crane.css";

.profile {
  width: 250px;
  margin: auto;
  background-color: var(--v-primary-base) !important;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.profile p {
  margin-bottom: 3px;
}
</style>
